import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLimit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLimit"><Path d="M5.07176 19.5C3.47685 17.8007 2.5 15.5144 2.5 13C2.5 7.75329 6.75329 3.5 12 3.5C17.2467 3.5 21.5 7.75329 21.5 13C21.5 15.5144 20.5231 17.8007 18.9282 19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 13L8.5 9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLimit;
